import { makeAutoObservable } from "mobx";
import { extensionsLoader } from "src/business/extensions/apiExtensions";
import { ZExtension } from "src/business/extensions/ZExtension";
import { RtColumn } from "src/components/ReactiveTable/RtColumn";
import { RtStore } from "src/components/ReactiveTable/RtStore";

import { createExtensionColumns } from "./createExtensionColumns";

export const extensionsPageStore = makeAutoObservable({
  table: new RtStore<ZExtension, {}>({
    rowKey: "id",
    loader: extensionsLoader(),
  }),
  get columns(): RtColumn<ZExtension>[] {
    return createExtensionColumns();
  },
});
